import { Dropdown, Layout, theme } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AvatarImage from "../../assets/images/default/avatar.svg";
import keyLockedIcon from "../../assets/images/icon/keyLockedIcon.svg";
import signoutIcon from "../../assets/images/icon/signoutIcon.svg";
import userIcon from "../../assets/images/icon/userIcon.svg";
import Logo from "../../assets/images/ieat_logo.png";
// import Logo from "../../assets/images/current_ieat_logo.svg";
import useAuth from "../../lib/hooks/useAuth";
import useRole from "../../lib/hooks/useRole";
import useSignOut from "../../lib/hooks/useSignout";
import { routes } from "../../routes";
import "./styles.css";

const { Header } = Layout;
const { useToken } = theme;

const Topbar = () => {
  const { token } = useToken();
  const { auth } = useAuth();
  const { setSignout } = useSignOut();
  const [roles] = useRole();
  const [role, setRole] = useState([]);

  useEffect(() => {
    const roleData = roles?.filter(
      (item) => item?.roleId === auth?.user?.roleId
    );
    setRole(roleData);
  }, [roles, setRole]);

  const items = [
    {
      key: "0",
      label: (
        <div className="w-full">
          <div className="flex items-center">
            <img
              src={AvatarImage}
              width={45}
              height={45}
              alt="logo"
              style={{ marginRight: 10, cursor: "pointer" }}
            />
            <div className="">
              <span>{auth?.user?.fullName}</span>
              <div
                className="line-clamp-1"
                style={{
                  backgroundColor: token.thPrimary,
                  borderRadius: 50,
                  fontSize: 12,
                  padding: "2px 8px",
                  color: "#fff",
                  width: "fit-content",
                }}
                title={`${role[0]?.roleNameTh}`}
              >
                {role[0]?.roleNameTh || "ยังไม่ระบุ"}
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <Link
          to={routes.profile + `/${auth?.user?.userId}`}
          className="flex items-center"
        >
          <img src={userIcon} width={16} height={16} alt="แก้ไขข้อมูลส่วนตัว" />{" "}
          แก้ไขข้อมูลส่วนตัว
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          to={routes.change_password + `/${auth?.user?.userId}`}
          className="flex items-center"
        >
          <img
            src={keyLockedIcon}
            width={16}
            height={16}
            alt="เปลี่ยนรหัสผ่าน"
          />{" "}
          เปลี่ยนรหัสผ่าน
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <div onClick={() => setSignout(true)} className="flex items-center">
          <img src={signoutIcon} width={16} height={16} alt="ออกจากระบบ" />{" "}
          <span style={{ marginLeft: 8 }}>ออกจากระบบ</span>
        </div>
      ),
    },
  ];

  return (
    <Header className="header topbar">
      <Link to={"/"} style={{ display: "flex", alignItems: "center" }}>
        <img src={Logo} height={50} alt="I-EA-T LOGO" />
        {/* <img src={Logo} width={50} height={50} alt="logo" /> */}
      </Link>
      <div className="flex items-center">
        <Dropdown
          overlayClassName="profileDropdown"
          menu={{
            items,
          }}
          placement="bottomRight"
          arrow={{
            pointAtCenter: true,
          }}
        >
          <img
            src={AvatarImage}
            width={30}
            height={30}
            alt="logo"
            style={{ marginRight: 10, cursor: "pointer" }}
          />
        </Dropdown>
        <span style={{ color: "white", fontWeight: 500 }}>
          {auth?.user?.fullName}
        </span>
      </div>
    </Header>
  );
};

export default Topbar;
